import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

// Set the workerSrc to the correct path for the PDF.js worker
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.12.313/pdf.worker.min.js`;

const PdfViewer = ({ url }) => {
  const [numPages, setNumPages] = useState(null);

  // This function is triggered when the document is successfully loaded
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages); // Set the total number of pages
  };

  return (
    <div>
      <Document
        file={url}
        onLoadSuccess={onDocumentLoadSuccess} // Event triggered on successful load
        onLoadError={(error) => console.log('Error loading PDF:', error)}
      >
        {/* Render each page by mapping over the page numbers */}
        {Array.from(new Array(numPages), (el, index) => (
          <Page key={`page_${index + 1}`} pageNumber={index + 1} />
        ))}
      </Document>
    </div>
  );
};

export default PdfViewer;
